module.exports = __webpack_public_path__ + "img/zain-logo-black2.53ff87e5.png";